module.exports = __webpack_public_path__ + "static/img/3.5caf550.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/sp/3.png
// module id = LveH
// module chunks = 0